import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import colors from '../shared/colours/colours';
import fontWeights from '../shared/fontWeights/fontWeights';
import typeSizes from '../shared/typeSizes/typeSizes';
export const allowedTypeSizes = [
    'large',
    'body',
    'small',
    'mini',
    'micro',
];
const Label = ({ typeStyle = 'small', color = 'base', fontWeight = 'regular', className, ...commonProps }) => {
    const classes = clsx(styles.root, typeSizes[typeStyle], colors[color], fontWeights[fontWeight], className);
    return Depot.createElement('label', {
        ...commonProps,
        className: classes,
    });
};
export default Label;
//# sourceMappingURL=index.js.map